/* eslint-disable react/prop-types */
import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import CompetitorSelectorComponent from "./CompetitorSelectorComponent";

const useStyles = makeStyles(() => ({
  addCompetitorItem: {
    alignItems: "center",
    backgroundColor: "#fff",
    border: "2px dotted #e0e0e0",
    borderRadius: "3px",
    cursor: "pointer",
    display: "flex",
    height: "45px",
    justifySelf: "center",
    userSelect: "none",
  },
  disabledAddCompetitorItem: {
    cursor: "not-allowed",
    backgroundColor: "#EEEEEE",
  },
  disabledAddCompeitorText: {
    paddingLeft: "30px",
  },
}));

const CompetitorAddItemsComponent = ({ label, unshowedItems, onAddItem }) => {
  const classes = useStyles();

  return unshowedItems.length > 0 ? (
    <Box className={`${classes.addCompetitorItem} `}>
      <CompetitorSelectorComponent
        label={label}
        selectableOptions={unshowedItems}
        onChange={onAddItem}
      />
    </Box>
  ) : (
    <Box
      className={`${classes.addCompetitorItem} ${classes.disabledAddCompetitorItem}`}
    >
      <Typography variant="body1" className={classes.disabledAddCompeitorText}>
        All elements added
      </Typography>
    </Box>
  );
};

export default CompetitorAddItemsComponent;
